// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box } from '@mui/material';
import { Sidebar } from '../components/Sidebar/Sidebar';
import { containerSx, mainContentSx } from '../modules/styles';
import { ModuleRoute } from '../routes/types';

interface CommonBridgeLayoutProps {
  entries: ModuleRoute[];
  children: React.ReactNode;
}
export const CommonBridgeLayout: React.FC<CommonBridgeLayoutProps> = ({ entries, children }) => {
  return (
    <Box sx={containerSx}>
      <Sidebar routes={entries} />
      <Box sx={mainContentSx}>{children}</Box>
    </Box>
  );
};
